import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { twoMTwoPayments } from "../../../../api/apiServices";
import Pagination from "../../../../services/Pagination";
import toast, { Toaster } from "react-hot-toast";
// import PaymentSearchBar from "../../../Common/Search/PaymentSearchBar";
import TwomtwoPaymentsByDate from "./TwomtwoPaymentsByDate";
import TwomtwoPaymentsByMonth from "./TwomtwoPaymentsByMonth";

import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const TwomtwoPaymentsReport = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/twomtwo_payments_report";

	const year = new Date().getFullYear() - 5;
	const years = Array.from(new Array(20), (val, index) => index + year);
	const curr = new Date();
	curr.setDate(curr.getDate());
	var date = curr.toISOString().substring(0, 10);

	const [state, setState] = useState({
		isAll: true,
		isByDate: false,
		isByMonth: false,
	});

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(15);

	const {
		isLoading,
		isError,
		error,
		data: payments,
	} = useQuery("payments", twoMTwoPayments, {
		select: (data) => data.sort((a, b) => b.id - a.id),
	});

	let total_payments = 0;
	let currentPosts = [];

	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	if (payments?.length > 0) {
		currentPosts = payments?.slice(indexOfFirstPage, indexOfLastPage);
		for (var i = 0; i < payments?.length; i++) {
			total_payments += payments[i].payment_amount;
		}
	}

	let allData = [];
	let byDate = [];
	let byMonth = [];

	const handlePaymentsByDate = () => {
		setState({
			...state,
			isByDate: true,
			isByMonth: false,
			isAll: false,
		});
	};
	const handlePaymentsByMonth = () => {
		setState({
			isByDate: false,
			isByMonth: true,
			isAll: false,
		});
	};

	for (var k = 0; k < payments?.length; k++) {
		allData.push({
			serial_no: k + 1,
			pf_number: payments[k].pf_number,
			full_name:
				payments[k].members?.first_name +
				" " +
				payments[k].members?.middle_name +
				" " +
				payments[k].members?.last_name,
			mobile_number: payments[k].mobile_number,
			payment_amount: payments[k].payment_amount,
			payment_date: payments[k].payment_date,
		});
	}

	let content;
	if (isLoading) {
		content = <p>Loading Payment Transactions...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg">
				<table className="table table-borderless table-striped">
					<caption className="table-caption">
						{" "}
						Total 2M2 Payment As At {format(
												new Date(date),
												dateFormat
											)}{" - "}
						<strong style={{ color: "var(--green)" }}>
							GHS
							{total_payments.toLocaleString(undefined, {
								minimumFractionDigits: 2,
							})}
						</strong>
					</caption>
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col" style={{ textAlign: "center" }}>
								Year
							</th>
							<th scope="col" style={{ whiteSpace: "nowrap" }}>
								PF Number
							</th>
							<th scope="col" style={{ whiteSpace: "normal" }}>
								Name
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Mobile Number
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Payment Date
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Amount Paid
							</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts.map((paymt, index) => (
							<tr key={paymt.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.year}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.pf_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.members?.first_name +
										" " +
										paymt?.members?.middle_name +
										" " +
										paymt?.members?.last_name}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.mobile_number}
								</td>
								<td style={{ textAlign: "center" }}>
									{format(
										new Date(paymt?.payment_date),
										dateFormat
									)}
								</td>

								<td style={{ textAlign: "right" }}>
									{paymt?.payment_amount.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</td>
							</tr>
						))}
					</tbody>
					<tbody>
						<tr>
							<th
								colSpan={"6"}
								style={{
									fontSize: "16px",
									fontWeight: "900",
									color: "white",
								}}
							>
								TOTAL 2M2 PAYMENTS AS AT {format(
												new Date(date),
												dateFormat
											)}
							</th>
							<th
								style={{
									fontSize: "16px",
									fontWeight: "900",
									color: "white",
									textAlign: "right",
								}}
							>
								{total_payments.toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>2M2 Payments</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							{state.isByDate && (
								<div className="panel-heading">
									<div className="row">
										<div className="col-sm-12">
											<h2 className="panel-title">
												2M2 Payments - By Date
											</h2>
										</div>
									</div>
								</div>
							)}
							{state.isByMonth && (
								<div className="panel-heading">
									{" "}
									2M2 Payments - By Month
								</div>
							)}
							{state.isAll && (
								<>
									<div className="panel-heading">
										<div className="row">
											<div className="col-sm-12">
												<h4 className="panel-title">
													<div className="col-sm-3">
														<button
															className="btn btn-success btn-block"
															onClick={
																handlePaymentsByDate
															}
														>
															<i className="fa fa-eye"></i>
															&nbsp; &nbsp;2M2
															Payments By Date
														</button>
														&nbsp; &nbsp;
													</div>
													<div className="col-sm-3">
														<button
															className="btn btn-success btn-block"
															onClick={
																handlePaymentsByMonth
															}
														>
															<i className="fa fa-eye"></i>
															&nbsp; &nbsp;2M2
															Payments By Month
														</button>
														&nbsp; &nbsp;
													</div>
												</h4>
											</div>
										</div>
									</div>
								</>
							)}
							<div className="panel-body">
								<div className="row"></div>
								<div className="row"></div>
								{state.isAll && <div className="row"></div>}
								<br />
								{state.isAll && content}

								{state.isByDate && (
									<TwomtwoPaymentsByDate
										payments={payments}
										setState={setState}
									/>
								)}
								{state.isByMonth && (
									<TwomtwoPaymentsByMonth
										payments={payments}
										setState={setState}
									/>
								)}
							</div>
							{state.isAll && (
								<div className="panel-footer">
									<Pagination
										data={payments ? payments : []}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								</div>
							)}
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default TwomtwoPaymentsReport;
